export const ESTABLISHMENT_STATUS = {
  MISSING_INFORMATIONS: "MISSING_INFORMATIONS",
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
  ACTIVATED: "ACTIVATED",
  DISABLED: "DISABLED",
};

export const ESTABLISHMENT_STATUS_OPTIONS = [
  { value: ESTABLISHMENT_STATUS.MISSING_INFORMATIONS, label: "Incomplet" },
  { value: ESTABLISHMENT_STATUS.WAITING_FOR_APPROVAL, label: "En attente d'approbation" },
  { value: ESTABLISHMENT_STATUS.ACTIVATED, label: "Actif" },
  { value: ESTABLISHMENT_STATUS.DISABLED, label: "Désactivé" },
];
